module.exports = __webpack_public_path__ + "img/bg-grey.8d7c1e35.svg";